import { Prisma } from "@prisma/client";
import { ticketTypeValues } from "./tickets.types";
import { badgeTypeValues } from "./badges.types";
import { Paginated, Sortable } from "./utils.types";

export const eventGateTypeValues =
  Prisma.validator<Prisma.EventGateDefaultArgs>()({
    select: {
      id: true,
      eventId: true,
      name: true,
      createdAt: true,
      updatedAt: true,
      ticketTypes: {
        include: ticketTypeValues.include,
      },
      badgeTypes: {
        include: badgeTypeValues.include,
      },
    },
  });

export type EventGate = Prisma.EventGetPayload<typeof eventGateTypeValues>;

export type EventGateFilters = Sortable<
  Paginated<{
    searchText?: string;
  }>
>;
